import { render } from "./Print_page_header.vue?vue&type=template&id=42ba2dd0"
import script from "./Print_page_header.vue?vue&type=script&lang=js"
export * from "./Print_page_header.vue?vue&type=script&lang=js"

import "./Print_page_header.vue?vue&type=style&index=0&id=42ba2dd0&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__